import * as React from 'react';

import { IfPermitted, Spinner } from 'components/common';
import SectionGrid from 'components/common/Section/SectionGrid';
import CollectionMembershipConfigSection from 'collections/components/CollectionMembershipConfigSection';

import ProfileSection from './ProfileSection';
import SharedEntitiesSection from './SharedEntitiesSection';
import UsersSection from './UsersSection';
import RolesSection from './RolesSection';
import CollectionsSection from './CollectionsSection';

import type Team from '../../logic/Team';

type Props = {
  team: Team | null | undefined;
};

const TeamDetails = ({ team }: Props) => {
  if (!team) {
    return <Spinner />;
  }

  return (
    <>
      <SectionGrid>
        <div>
          <ProfileSection team={team} />
        </div>
        <div>
          <IfPermitted permissions={`team_users:list:${team.id}`}>
            <UsersSection team={team} />
          </IfPermitted>
          <RolesSection team={team} />
          <CollectionMembershipConfigSection entityId={team.id} entityType="team" readOnly />
          <CollectionsSection team={team} />
        </div>
      </SectionGrid>
      <SharedEntitiesSection teamId={team.id} />
    </>
  );
};

export default TeamDetails;
